module.exports = __webpack_public_path__ + "static/media/tada.6f8dea6b.ogg";